// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlayCircle: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 42 42" enableBackground="new 0 0 42 42" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M21,0.17C9.5,0.17,0.17,9.5,0.17,21S9.5,41.83,21,41.83S41.83,32.5,41.83,21
	S32.5,0.17,21,0.17z M16.83,30.38V11.62L29.33,21L16.83,30.38z"/>
</svg>;
};

export default React.memo(PlayCircle);
